import { render, staticRenderFns } from "./ProductsHead.vue?vue&type=template&id=b860311c"
import script from "./ProductsHead.vue?vue&type=script&lang=js"
export * from "./ProductsHead.vue?vue&type=script&lang=js"
import style0 from "./ProductsHead.vue?vue&type=style&index=0&id=b860311c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports